import TextFade from "../../components/CustomTexts/TextFade";
import CallToActionSection from "../../components/Others/CallToActionSection";
import heroImage from "../../assets/Farm/gallery.jpg";
import sandDredgingImage from "../../assets/SIMDOZI-PNGArtboard-3.png";
import missionImage from "../../assets/SIMDOZI-PNGArtboard-2-copy.png";
import TextEffect from "../../components/CustomTexts/TextEffect";
import bgIMG from "../../assets/tan_bkgrd.jpg";
import trainingImg from "../../assets/training.jpg";
import chysonImg from "../../assets/chysonbig.png";
import farmImg from "../../assets/Soil-Sampling/Soil Sampling - 9.jpg";
import supplyImg from "../../assets/Vine-Cutting- Planting/Vine Cutting and Planting - 6.jpg";
import consultancyImg from "../../assets/Ohaji-Farm/nice.jpg";
import establishmentImg from "../../assets/Irrigation-System/Irrigation System - 7.jpg";

const SandDredgingPage = () => {
  const offerings = [
    {
      title: "Training",
      image: trainingImg,
      path: "/services/training",
    },
    {
      title: "Chyson Foods",
      image: chysonImg,
      subtitle: "Processed Potato Products & Fresh Orange Fleshed Sweet Potato Tubers",
      path: "/services/chyson-foods",
    },
    {
      title: "Soil Sampling",
      image: farmImg,
      path: "/services/farming#establishment",
    },
    {
      title: "Vine Cutting & Planting",
      subtitle: "Vine multiplication business",
      image: supplyImg,
      path: "/services/farming#supply",
    },
    {
      title: "Ohaji Farm",
      image: consultancyImg,
      path: "/services/farming#consultancy",
    },
    {
      title: "Irrigation System ",
      image: establishmentImg,
      path: "/services/farming#establishment",
    },
  ];

  return (
    <div className="about-container">
      {/* Hero Section */}
      <div
        className="relative h-[60vh] flex items-center justify-center text-white bg-cover bg-center z-0"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-black opacity-50 z-0"></div>
        <div className="z-10">
          <TextEffect text="What We Do" className="hero-title" />
        </div>
      </div>

      {/* What We Offer */}
      <div className="flex px-4 sm:px-[5%] md:flex-row flex-col justify-between items-center mt-20 md:gap-20 gap-10">
        <div className="md:w-[55%] w-full">
          <TextFade animation="fade-down">
            <h1 className="md:text-[60px] text-[28px] font-bold text-dark mb-6">
              <TextEffect part3="What We Offer" />
            </h1>
          </TextFade>
          <p className="text-dark md:text-[20px] text-[15px] leading-relaxed">
            We offer both fresh OFSP tubers and a wide range of value-added products, including fermented and regular flours, crispy granules, fries, dried chips, and even our signature OFSP bread. These are not just tasty—they’re functional foods aimed at improving health outcomes.
          </p>
          <p className="text-dark md:text-[20px] text-[15px] mt-4 leading-relaxed">
            Beyond products, we provide training, farm establishment, vine supply, and consultancy services to support the full agricultural value chain.
          </p>
        </div>

        <div className="md:w-[45%] w-full flex justify-center md:justify-end">
          <img
            src={sandDredgingImage}
            alt="Dredging History"
            className="w-[90%] sm:w-full max-w-[450px] md:max-w-[600px]"
          />
        </div>
      </div>

      {/* We Help Farmers Section */}
      <div className="relative mt-32">
        <div
          className="relative bg-green-500 text-white px-4 sm:px-[5%] py-20 bg-cover bg-center z-0"
          style={{ backgroundImage: `url(${bgIMG})` }}
        >
          <div className="absolute inset-0 bg-green-650 opacity-80 z-0"></div>
          <div className="relative z-10 flex md:flex-row flex-col justify-between items-center gap-16">
            <div className="md:w-[40%] w-full flex justify-center">
              <img
                src={missionImage}
                alt="Empowering Farmers"
                className="w-[80%] sm:w-full max-w-[350px] md:max-w-[450px]"
              />
            </div>
            <div className="md:w-[100%] w-full">
              <TextFade animation="fade-down">
                <h1 className="text-[20px] sm:text-[30px] md:text-[40px] font-bold text-white mb-4 leading-tight">
                  <TextEffect text1="We Help Farmers " />
                </h1>
              </TextFade>
              <p className="text-white text-[15px] sm:text-[17px] md:text-[20px] leading-relaxed">
                We go out into the world to provide training and resources that empower small-scale farming families to thrive. From the farm to your table, Simdozi is committed to making nutritious food more accessible, affordable, and sustainable for all.
              </p>
              <button className="mt-6 bg-secondary text-white px-5 py-2 rounded-md font-medium sm:font-semibold w-fit hover:scale-105 hover:shadow-lg transition-all duration-300 text-sm sm:text-base">
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Our Products Header */}
      <div className="px-4 sm:px-[5%] mt-20">
        <TextFade animation="fade-down">
          <h1 className="text-[28px] md:text-[60px] font-bold text-dark mb-6">
            <TextEffect part2="Our" /> <TextEffect part2="Services" />
          </h1>
        </TextFade>
      </div>

      {/* Offerings Cards */}
      <div className="w-full grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-10 sm:gap-8 px-4 sm:px-[5%] my-20 relative z-[1]">
        {offerings.map((item, index) => (
          <div
            key={index}
            className="relative group h-[300px] w-full rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500"
          >
            <div
              className="absolute inset-0 bg-cover bg-center group-hover:scale-110 transition-transform duration-500"
              style={{ backgroundImage: `url(${item.image})` }}
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 group-hover:bg-opacity-60 transition duration-500" />
            <div className="relative z-10 h-full flex flex-col justify-end p-6 text-white">
              <h3 className="text-xl sm:text-2xl font-bold">{item.title}</h3>
              {item.subtitle && <p className="text-xs sm:text-sm mt-2">{item.subtitle}</p>}
              <a
                href={item.path}
                className="mt-3 text-xs sm:text-sm inline-block bg-white text-black px-3 py-1.5 sm:px-4 sm:py-2 rounded font-medium sm:font-semibold hover:bg-secondary hover:text-white transition"
              >
                Learn More
              </a>
            </div>
          </div>
        ))}
      </div>

      <CallToActionSection />
    </div>
  );
};

export default SandDredgingPage;
